import { forwardRef, type AnchorHTMLAttributes } from 'react';
import { Link } from 'react-router';

type Props = AnchorHTMLAttributes<HTMLAnchorElement> & { href?: string };

/** Routes Astryx links through React Router; external/tel/mailto stay native. */
export const RouterLink = forwardRef<HTMLAnchorElement, Props>(function RouterLink(
  { href = '', ...rest },
  ref,
) {
  const isExternal = /^[a-z][a-z0-9+.-]*:/i.test(href) || href.startsWith('//');
  if (isExternal || rest.target === '_blank' || rest.download !== undefined) {
    return <a ref={ref} href={href} {...rest} />;
  }
  return <Link ref={ref} to={href} {...rest} />;
});
